<form *ngIf="reportForm" [formGroup]="reportForm">
  <div class="row row d-flex justify-content-center my-3">
    <div class="col-12">
      <div class="form-group">
        <label>คำอธิบายรายงานแบบทดสอบ</label>
        <textarea formControlName="TEMPLATE_DES" class="form-control" rows="3" maxlength="1500"></textarea>
        <p class="text-right">{{ reportForm.value.TEMPLATE_DES.length | number }}/1,500</p>
      </div>
    </div>

    <h3 class="text-center my-4">ลักษณะทางจิตวิทยา</h3>
    <div class="col-12">
      <div *ngFor="let r of reportForm.get('PSY_BLOCKS')['controls']; let i = index" formArrayName="PSY_BLOCKS">
        <div [formGroupName]="i" class="box mt-4">
          <button *ngIf="i !== 0" mat-mini-fab class="img close-btn" (click)="removePsyBlocks(i)"
            [style.backgroundImage]="'url(\'../../../../assets/close.png\')'"></button>
          <div class="form-group row" style="margin-top: 60px;">
            <label class="col-sm-3 col-form-label">ลักษณะทางจิตวิทยา</label>
            <div class="col-sm-9">
              <input formControlName="PSY_NAME" type="text" class="form-control" (change)="updatePsyName(r)">
            </div>
          </div>

          <div class="form-group row">
            <label class="col-3 col-form-label">สี</label>
            <div class="col-sm-9">
              <input formControlName="COLOR_CODE" type="color" class="form-control" style="width: 20%;">
              <small *ngIf="!r.value.COLOR_CODE" class="col-form-label" class="text-danger">
                ยังไม่ได้ใส่สี ✖
              </small>
              <small *ngIf="r.value.COLOR_CODE" class="col-form-label" class="text-success">
                ใส่สีเรียบร้อย ✔
              </small>
            </div>
          </div>

          <div class="form-group">
            <label class="col-form-label">คำอธิบายลักษณะทางจิตวิทยา</label>
            <textarea formControlName="DETAIL_PSY" class="form-control" rows="3" maxlength="1500"></textarea>
            <p class="text-right">{{ reportForm.value.PSY_BLOCKS[i].DETAIL_PSY.length | number }}/1,500</p>
          </div>

          <div class="row justify-content-center">
            <lifedi-btn *ngIf="!r.value.CAL" lable="การคำนวณ" (click)="openCalculateModal(r, i, false)"
              customStyle="background-color: #060E9F; color: #FFF; margin: 0px 5px 10px 0px; padding: 0 30px;">
            </lifedi-btn>
            <lifedi-btn *ngIf="r.value.CAL" lable="แก้ไขการคำนวณ" (click)="openCalculateModal(r, i, true)"
              customStyle="background-color: #060E9F; color: #FFF; margin: 0px 5px 10px 0px; padding: 0 30px;">
            </lifedi-btn>
          </div>

          <div class="row justify-content-center">
            <small *ngIf="!r.value.CAL" class="col-form-label" class="text-danger">
              ยังไม่ได้ใส่วิธีการคำนวณ ✖
            </small>
            <small *ngIf="r.value.CAL" class="col-form-label" class="text-success">
              ใส่วิธีการคำนวณแล้ว ✔
            </small>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <lifedi-btn lable="เพิ่มลักษะทางจิตวิทยา" (click)="addGroup();"
          customStyle="background-color: #00AF80; color: #FFF; margin: 20px 5px 20px 0px; padding: 0 30px;">
        </lifedi-btn>
      </div>
    </div>

    <h3 class="text-center my-4">Ideal Profile</h3>
    <div class="col-12">
      <div *ngFor="let ideal of reportForm.get('IDEAL_DATA')['controls']; let i = index;" formArrayName="IDEAL_DATA">
        <div [formGroupName]="i" class="box mt-4">
          <button *ngIf="i !== 0" mat-mini-fab class="img close-btn" (click)="removeIdealBlocks(i)"
            [style.backgroundImage]="'url(\'../../../../assets/close.png\')'"></button>
          <h3 class="text-center pt-3">Ideal {{i+1}}</h3>
          <div class="form-group row">
            <div class="form-group col-12">
              <div class="row">
                <label class="col-2">ชื่อโปรไฟล์</label>
                <div class="col-10">
                  <input formControlName="IDEAL_NAME" type="text" class="form-control">
                </div>
              </div>
            </div>
            <div *ngFor="let pb of ideal.get('IDEALS')['controls']; let j = index;" class="form-group col-12"
              formArrayName="IDEALS">
              <div [formGroupName]="j" class="row">
                <label class="col-2 col-form-label">ชื่อด้าน</label>
                <div class="col-7">
                  <input formControlName="PSY_NAME" class="form-control" type="text" [attr.disabled]="true">
                </div>
                <label class="col-1 col-form-label">คะแนน</label>
                <div class="col-2"><input formControlName="POINT" class="form-control" type="number"
                    (change)="updatePoint(ideal, $event, j)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-2 justify-content-center">
        <button mat-mini-fab class="img" (click)="addIdeal()"
          [style.backgroundImage]="'url(\'../../../../assets/add.png\')'">
        </button>
      </div>
    </div>

  </div>
</form>
